<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" destroy-on-close title="申请退款" width="800px">
		<div>
			<h6 class="trade-no">订单号：{{ curTradeNo }}</h6>
			<div class="flexCenter" style="justify-content: start" v-for="(ginfo, index) in paperStandardProduct" :key="index" @click="togglePaperSelection(ginfo, index)">
				<div class="goods-item flexBetween" v-if="ginfo.isDigit == 0">
					<div>
						<!-- checked -->
						<el-checkbox v-model="ginfo.checked" :disabled="ginfo.disabled" @change="togglePaperSelection(ginfo, index)"></el-checkbox>
					</div>
					<div style="flex: 1; margin: 0 20px">
						<div class="g-title">
							<span :class="ginfo.isDigit == 0 ? 'colorblue' : ginfo.isDigit == 1 ? 'colorgreen' : 'colorred'">【{{ ginfo.isDigit == 0 ? '纸质版' : ginfo.isDigit == 1 ? '电子版' : '智能文档' }}】</span>
							{{ ginfo.spuName }}
						</div>
						<!-- <p class="good-desc card-date sku">{{ ginfo.skuName }}</p> -->
						<p class="good-desc card-date sku colorred" style="margin-top: 8px" v-if="ginfo.isDigit != 0"><i class="el-icon-warning-outline"></i>非纸质版不可申请退款</p>
					</div>

					<div class="goods-number">{{ ginfo.salePrice }}元 X {{ ginfo.buyNum }}</div>
				</div>
			</div>
		</div>
		<!-- <div class="refund-reason">
			<h6>选择退款理由</h6>
			<el-select v-model="refundReason" placeholder="请选择" size="small" style="width: 100%">
				<el-option v-for="item in refundReasonList" :key="item.id" :label="item.reasonName" :value="item.id"> </el-option>
			</el-select>
		</div>
		<div class="refund-reason">
			<h6>上传图片</h6>
			<UploadImageList ref="UploadImageListRef" v-model="fileList" :fileType="['png', 'jpg', 'jpeg']" :limit="5" :file-size="10" @change="handleFileChange"></UploadImageList>
		</div> -->
		<div class="refund-reason">
			<h6>退款具体原因</h6>
			<el-input v-model="refundReasonInfo" placeholder="请输入" size="small" style="width: 100%" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 确定 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { postConsumerOrderRefund, getConsumerOrderRefundReason } from '@/api/order/order.js';
import UploadImageList from '@/components/UploadImageList/index.vue';

export default {
	name: 'DialogOrderRefund',
	props: {
		curTradeNo: {
			type: String,
			default: ''
		},
		curGoods: {
			type: Array,
			default: () => []
		}
	},
	components: {
		UploadImageList
	},
	data() {
		return {
			dialogVisible: false,
			paperStandardProduct: [],
			refundReason: '',
			refundReasonInfo: '',
			refundReasonList: [
				// {
				// 	value: 1,
				// 	label: '商品质量问题'
				// },
				// {
				// 	value: 2,
				// 	label: '商品与描述不符'
				// },
				// {
				// 	value: 3,
				// 	label: '其他问题'
				// }
			],
			fileList: []
		};
	},
	watch: {
		dialogVisible(val) {
			if (val) {
				this.getConsumerOrderRefundReason();
			} else {
				this.refundReason = '';
				this.refundReasonInfo = '';
			}
		},

		curGoods: {
			handler(val) {
				if (!val.length) {
					return;
				}
				this.paperStandardProduct = val.map(item => {
					return {
						...item
					};
				});
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		handleFileChange(fileList) {
			// console.log('fileList', fileList);
			// const prefix = '/third/files/info/';
			// const key = fileList.replace(prefix, '');
			// this.form.feebackAnnex = key;
			// 手动触发表单验证
			// if (this.$refs.form) {
			// 	this.$refs.form.validateField('files');
			// }
		},

		getConsumerOrderRefundReason() {
			getConsumerOrderRefundReason().then(res => {
				this.refundReasonList = res.data;
			});
		},

		togglePaperSelection(curItem, index) {
			if (curItem.isDigit != 0) {
				return;
			}
			const newItem = { ...curItem, checked: !curItem.checked };
			this.$set(this.paperStandardProduct, index, newItem);
		},

		handleClose() {
			this.$emit('cancel');
		},

		handleConfirm() {
			let checkedItems = this.paperStandardProduct.filter(item => item.checked);
			if (!checkedItems.length) {
				TMessage.warning('请选择要申请退款的商品');
				return;
			}
			// if (!this.refundReason) {
			// 	TMessage.warning('请选择退款理由');
			// 	return;
			// }
			// let fileList = this.$refs.UploadImageListRef.fileList;
			// let imageInfo = [];
			// if (fileList.length > 0) {
			// 	fileList.forEach(item => {
			// 		imageInfo.push(item.url);
			// 	});
			// }

			let params = {
				tradeNo: this.curTradeNo,
				refundReason: this.refundReason,
				refundReasonInfo: this.refundReasonInfo,
				goodIdList: [],
				imageInfo:[]
			};
			checkedItems.forEach(item => {
				params.goodIdList.push(item.skuId);
			});
			this.postConsumerOrderRefund(params);
		},

		postConsumerOrderRefund(params) {
			// console.log(params);
			postConsumerOrderRefund(params).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					TMessage.success('申请退款提交成功');
					// this.$refs.UploadImageListRef.clearFileList();
					this.dialogVisible = false;
					this.$emit('confirmInfo');
				} else if (msg) {
					TMessage.warning(msg);
				} else {
					TMessage.warning('申请退款提交失败');
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
.refund-reason h6 {
	margin: 15px 0;
	font-size: 14px;
	font-weight: normal;
}
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}

.trade-no {
	padding: 0 15px;
	border: 1px solid #d0e3f9;
	font-size: 14px;
	line-height: 40px;
	color: #888;
	height: 40px;
	background-color: #e3eeff;
	margin: 0;
}

.goods-item {
	width: 100%;
	// margin-right: 40px;
	border: 1px solid #d0e3f9;
	margin-top: -1px;
	padding: 15px;
	cursor: pointer;
}
.good-desc {
	margin: 10px 0;
}
.g-atcs {
	margin-top: 12px;
}
.g-title {
	// margin-bottom: 8px;
}
.g-stitle {
	margin-bottom: 20px;
	font-size: 12px;
	color: #888888;
}
.number {
	margin-right: 30px;
}
em {
	font-weight: bold;
	font-style: normal;
}
.ftx-13 {
	font-size: 12px;
	color: #888888;
	border-top: 1px solid #888888;
	padding-top: 5px;
	display: inline-block;
}
</style>
